import { IComponentOptions, IController, IPromise } from "angular";
import { GtmhubController } from "@gtmhub/core";
import { IUIError, UIErrorHandlingService } from "@gtmhub/error-handling";
import { IPlugin, PluginContext, UIPluginAttachPoint, filterUIPluginsByAttachPoint } from "@gtmhub/plugins";
import { PluginsActions } from "@gtmhub/plugins/redux/plugin-actions";
import { IPluginsStoreState } from "@gtmhub/plugins/redux/plugin-reducer";
import { IExtendedRootScopeService } from "@gtmhub/shared/ng-extensions";
import { INgRedux } from "@gtmhub/state-management";
import { Item } from "../plugin/plugin.component";

const bindStateToThis = (state: IPluginsStoreState, accessPoint: UIPluginAttachPoint): Record<string, unknown> => {
  return {
    plugins: filterUIPluginsByAttachPoint(state.plugins.items, accessPoint),
    pluginsFetched: state.plugins.isFetched,
    reduxStateError: state.plugins.error,
  };
};
export class PluginsCtrl extends GtmhubController implements IController {
  public accessPoint: UIPluginAttachPoint;
  public context: PluginContext;
  public item: Item;
  public reduxStateError: IUIError;
  public pluginsFetched: boolean;

  public plugins: IPlugin[];
  static $inject = ["$scope", "PluginActions", "$ngRedux", "UIErrorHandlingService"];

  constructor(
    private $scope: IExtendedRootScopeService,
    private pluginActions: PluginsActions,
    private $ngRedux: INgRedux,
    private uiErrorHandlingService: UIErrorHandlingService
  ) {
    super();
  }

  $onInit(): IPromise<unknown> {
    this.onDestroy(this.$ngRedux.connect((state: IPluginsStoreState) => bindStateToThis(state, this.accessPoint))(this));
    this.$ngRedux.dispatch(this.pluginActions.getPlugins());

    return this.$scope
      .watchUntilAndRejectOnError(
        () => this.pluginsFetched,
        () => this.reduxStateError
      )
      .then(
        () => null,
        (error) => this.uiErrorHandlingService.handleModal(error)
      )
      .catch((error) => this.uiErrorHandlingService.handleModal(error));
  }
}

export const PluginsComponent: IComponentOptions = {
  controller: PluginsCtrl,
  bindings: {
    accessPoint: "@",
    context: "@",
    item: "<",
  },
  template: require("./plugins.component.html"),
};
